import { supabase } from '../supabaseClient';

/**
 * Calls one of the app's own server functions (api/*) as the person signed in.
 *
 * The database is reached straight from the browser; these are for what the
 * browser must never do itself — talk to Mercado Pago or ARCA with a
 * professional's secrets. The function checks who is calling from the session
 * token sent here, and the database decides what they may do.
 *
 * Resolves to the JSON answer; rejects with the server's own sentence.
 */
export const callServer = async (name, body = {}) => {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) throw new Error('Iniciá sesión de nuevo.');

  let response;
  try {
    response = await fetch(`/api/${name}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch {
    throw new Error('Sin conexión. Probá de nuevo.');
  }

  let answer = {};
  try { answer = await response.json(); } catch { answer = {}; }
  if (!response.ok) throw new Error(answer.error || `No pudimos completarlo (HTTP ${response.status}).`);
  return answer;
};
